import React, { FC } from "react";
import NcImage from "shared/NcImage/NcImage";
import rightImgDemo from "images/BecomeAnAuthorImg.png";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useSetRecoilState } from "recoil";
import { modalState } from "../../atoms/modalAtom";

export interface SectionBecomeAnAuthorProps {
  className?: string;
  rightImg?: string;

  title?: string;
  text?: string;
  btn?: string;
}

const SectionBecomeAnAuthor: FC<SectionBecomeAnAuthorProps> = ({
  className = "",
  rightImg = rightImgDemo,

  title,
  text,
  btn,
}) => {
  const setModal = useSetRecoilState(modalState);
  return (
    <div
      className={`nc-SectionBecomeAnAuthor relative flex flex-col lg:flex-row items-center  ${className}`}
      data-nc-id="SectionBecomeAnAuthor"
    >
      <div className="flex-shrink-0 mb-16 lg:mb-0 lg:mr-10 lg:w-2/5">
        <h2 className="font-semibold text-3xl sm:text-4xl mt-6 sm:mt-11">
          {title ? title : "🤷‍♂️ Zašto izabrati nas?"}
        </h2>
        <span className="block mt-6 text-neutral-500 dark:text-neutral-400">
          {text
            ? text
            : "Kažu da je vreme novac, a sigurni smo da ne želiš da gubiš svoj novac? Zato smo mi tu da ti uštedimo vreme i novac! Mi smo tim kreativaca i inspirisanih ljudi koji rade ono što vole. Pažljivo biramo projekte koji nam odgovaraju i maksimalno im se posvećujemo. Prestani da trošiš vreme na stvari koje te ne zanimaju i prepusti ceo marketing nama, a rezultati su zagarantovani."}
        </span>
        <ButtonPrimary
          className="mt-6 sm:mt-11"
          onClick={() => setModal({ isOpen: true })}
        >
          {btn ? btn : "Zatraži ponudu"}
        </ButtonPrimary>
      </div>
      <div className="flex-grow">
        <NcImage src={rightImg} />
      </div>
    </div>
  );
};

export default SectionBecomeAnAuthor;